import './JobCard.css';
//import { Link } from 'react-router-dom';
import { FaBuilding, FaGraduationCap, FaClock, FaCalendarCheck, FaWhatsapp, FaTelegramPlane} from 'react-icons/fa';

function JobCard({ job }) {
  const postedDate = job.postedDate ? new Date(job.postedDate).toLocaleDateString('en-GB'):'_';
  const startDate = job.startDate ? new Date(job.startDate).toLocaleDateString('en-GB'):'_';
  const lastDateObj = new Date(job.lastDate);
  const lastDate = job.lastDate ? lastDateObj.toLocaleDateString('en-GB'):'_';

  const now = new Date();
  const timeDiff = lastDateObj - now;
  const daysLeft = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));

  // Status badge logic based on lastDate
  let statusBadge = null;
  if (daysLeft < 0) {
    statusBadge = <span className="status-badge expired">❌ Expired</span>;
  } else if (daysLeft <= 5) {
    statusBadge = <span className="status-badge soon">⚠️ Expiring Soon</span>;
  } else {
    statusBadge = <span className="status-badge active">✅ Active</span>;
  }

  const shareUrl = encodeURIComponent(`${window.location.origin}/jobs/${job._id}`);
  const shareText = encodeURIComponent(`Check out this job: ${job.title} at ${job.department}`);
  const platforms = {
    whatsapp: `https://wa.me/?text=${shareText}%20${shareUrl}`,
    telegram: `https://t.me/share/url?url=${shareUrl}&text=${shareText}`,
  };

  return (
    //<Link to={`/jobs/${job._id}`} className="job-card-link">
      <div className="job-card">
        {statusBadge}
        <h2>{job.title}</h2>        
        <p><FaBuilding /> <strong>Department:</strong> {job.department}</p>
        <p><FaGraduationCap /> <strong>Qualification:</strong> {job.qualification}</p>
        <p><FaCalendarCheck /> <strong>Start Date:</strong><span style={{color:'green', fontSize:'inherit', fontWeight:'bold'}}> {startDate}</span></p>
        <p><FaClock /> <strong>Last Date:</strong><span style={{ color: 'red', fontSize:'inherit', fontWeight:'bold'}}> {lastDate}</span></p>
        <a href={`/jobs/${job._id}`}>More Details ...</a>
        <p style={{fontSize: '0.6rem', position:'relative',textAlign:'left'}}>Posted: {postedDate}</p>
        <div className='share-options'> 
          <a href={platforms.whatsapp} target="_blank" rel="noopener noreferrer" title="WhatsApp"><FaWhatsapp /></a>
          <a href={platforms.telegram} target="_blank" rel="noopener noreferrer" title="Telegram" style={{color:'#158c9cff'}}><FaTelegramPlane /></a>
        </div>
        
      </div>
    //</Link>
  );
}

export default JobCard;
